import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Hero } from './components/sections/Hero';
import { Process } from './components/sections/Process';
import { DayOneToPlan } from './components/sections/DayOneToPlan';
import { TrustedBy } from './components/sections/TrustedBy';
import { Benefits } from './components/sections/Benefits';
import { Services } from './components/sections/Services';
import { Testimonials } from './components/sections/Testimonials';
import { WorldClassTalent } from './components/sections/WorldClassTalent';
import { TeamCarousel } from './components/sections/TeamCarousel';
import { CaseStudies } from './components/sections/CaseStudies';
import { NoInterviewBand } from './components/sections/NoInterviewBand';
import { Pricing } from './components/sections/Pricing';
import { FAQ } from './components/sections/FAQ';
import { Footer } from './components/sections/Footer';
import { CaseStudyDetail } from './components/pages/CaseStudyDetail';
import { BookingPage } from './components/pages/BookingPage';
import { MobileCTABar } from './components/MobileCTABar';
// Home page component that contains all sections
const Home = () => {
  return <>
      <main data-id="element-0">
        <Hero data-id="element-1" />
        <Process data-id="element-2" />
        <DayOneToPlan data-id="element-3" />
        <TrustedBy data-id="element-4" />
        <Benefits data-id="element-5" />
        <Services data-id="element-6" />
        <Testimonials data-id="element-7" />
        <WorldClassTalent data-id="element-8" />
        <TeamCarousel data-id="element-9" />
        <CaseStudies data-id="element-10" />
        <NoInterviewBand data-id="element-11" />
        <Pricing data-id="element-12" />
        <FAQ data-id="element-13" />
        <MobileCTABar data-id="element-14" />
      </main>
    </>;
};
export function App() {
  return <BrowserRouter data-id="element-15">
      <div className="font-sans" data-id="element-16">
        <Navbar data-id="element-17" />
        <Routes data-id="element-18">
          <Route path="/" element={<Home data-id="element-20" />} data-id="element-19" />
          <Route path="/case-study/:id" element={<CaseStudyDetail data-id="element-22" />} data-id="element-21" />
          <Route path="/book-meeting" element={<BookingPage data-id="element-24" />} data-id="element-23" />
        </Routes>
        <Footer data-id="element-25" />
      </div>
    </BrowserRouter>;
}